import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section id="about" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-7xl grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div>
          <span className="inline-flex items-center px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold whitespace-nowrap">
            <i className="ri-information-line text-sm mr-1" />
            USFans Spreadsheet
          </span>
          <h2 className="mt-4 text-2xl md:text-4xl font-heading font-semibold text-foreground-950 leading-tight">
            {t('about.title')}
          </h2>
          <p className="mt-5 text-foreground-600 text-sm md:text-base leading-relaxed">{t('about.copy')}</p>
          <div className="mt-6">
            <Link
              to="/guides/usfans-spreadsheet-guide"
              className="inline-flex items-center gap-2 h-11 px-5 rounded-md bg-foreground-950 text-background-50 text-sm font-semibold whitespace-nowrap hover:bg-foreground-800 transition-colors"
            >
              {t('about.cta')}
              <i className="ri-arrow-right-line text-base" />
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {[
            { icon: 'ri-list-check-2', label: 'Organized' },
            { icon: 'ri-compass-3-line', label: 'Discoverable' },
            { icon: 'ri-scales-3-line', label: 'Comparable' },
            { icon: 'ri-lightbulb-line', label: 'Practical' },
          ].map((item) => (
            <div key={item.label} className="p-6 rounded-lg bg-background-50 border border-background-200 text-center">
              <span className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                <i className={`${item.icon} text-2xl`} />
              </span>
              <p className="mt-3 text-sm font-semibold text-foreground-900 whitespace-nowrap">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}